import mapKeys from 'utils/mapKeys';

export default mapKeys(['SHOW_SNACKBAR', 'HIDE_SNACKBAR']);
